import React, {useCallback, useContext} from "react";
import styled from "styled-components";
import {ButtonWidget} from "../../../widget/pub/button_widget";
import {ModalContext} from "../../../provider/model_provider";
import {useParams} from "react-router-dom";
import {TisResultModel} from "./result_modal";
import {useModel} from "../../../hook/use_model";
import {NSURE} from "../../../web3/token.config";
import BigNumber from "bignumber.js";
import {useWeb3} from "../../../provider/web3_provider";
import {PayModal} from "./pay_modal";
import {useClaimPay} from "../fn/claim_pay";
import {CLAIMLIST} from "../index";

export const ChallengeResultWidget: React.FC<{type:CLAIMLIST}> = ({type}) => {
    const {onPresent} = useContext(ModalContext);
    const params = useParams<{ id: string, type: string }>();
    const {listToken,} = useWeb3();

     const handleClaim = useClaimPay(params.id);


    const [handlePresent] = useModel(<PayModal biggest={listToken[NSURE]}
                                                   buttonText={"Pay"}
                                                   confirmationFn={async (ev: BigNumber) => {
                                                       return await handleClaim(ev);
                                                   }}/>);

    const handleArbitration = useCallback((type: string) => {
        onPresent(<TisResultModel
            claim_id={parseInt(params.id)}
            type={type}
        />)
    }, [params])

    return (
        <>
            {
                type === CLAIMLIST.claimListChallenge &&  <WapStyle>
                    <div className="title">
                        Challenge Result
                    </div>

                    <div className="buttons">
                        <ButtonWidget
                            onClick={() => handleArbitration('true')}
                            bgColor={'#0064FD'}
                            text={'challenge success'}
                            size={{x: 10, y: 40}}
                        />
                        <ButtonWidget
                            onClick={() => handleArbitration('false')}
                            bgColor={'#0064FD'}
                            text={'challenge fail'}
                            size={{x: 10, y: 40}}
                        />
                    </div>


                </WapStyle>
            }

            {type === CLAIMLIST.claimListPay && <WapStyle>
                <div className="title">
                    Claim Pay
                </div>

                <div className="buttons">
                    <ButtonWidget
                        onClick={handlePresent}
                        bgColor={'#0064FD'}
                        text={'Claim Pay'}
                        size={{x: 10, y: 40}}
                    />

                </div>


            </WapStyle>}
            
        </>

        

    );
}


const WapStyle = styled.div`
  background-color: white;
  margin-top: 20px;

  .buttons {
    display: flex;
    justify-content: space-around;
    padding: 50px 0;
    width: 60%;
    margin: 0 auto;
  }

  .title {
    height: 55px;
    background-color: #EAF2FF;
    line-height: 55px;
    padding-left: 20px;
  }
`
